export default __webpack_public_path__ + "0bf28b0afb0f93ae491d64ab02902013.png";